<template>
	<div v-if="customers">
		<template v-if="customers.length">
			<label v-for="customer in customers" class="label label-default">
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/customers/' + customer.id">
					<template v-if="$platform.setting.customers.custom_reference">
						{{ customer.reference }}
					</template>
					<template v-else>
						{{ $platform.setting.number_symbol }}{{ customer.id }}
					</template>
				</router-link>
			</label>
		</template>
	</div>
</template>

<script>
	export default {
		props: ['customers'],
		data () {
			return {
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/ExistsCustomers.vue